
const systemService = {

  systemInfo: {
    name: '小桥字帖后台管理',
    version: '1.0.0',
    logo: null,
    primaryColor: '#f7f7fa',
    apiBaseUrl: 'https://api.xiaozhizitie.online',
    defaultAvatar: require('@/assets/111.jpg'),
    userAvatarFormat: '{baseUrl}/uploads/{avatar}?t={timestamp}'
  },

  getSystemName() {
    return this.systemInfo.name;
  },

  getSystemVersion() {
    return this.systemInfo.version;
  },

  getMenus(userRole) {
      const  baseMenus = [
        {
          path: '/category',
          title: '分类管理',
          icon: 'el-icon-menu',
          roles: ['管理员', '普通用户']
        },
        {
          path: '/textbook',
          title: '教材管理',
          icon: 'el-icon-notebook-1',
          roles: ['管理员'],
        },
        {
          path: '/title',
          title: '标题管理',
          icon: 'el-icon-edit-outline',
          roles: ['管理员', '普通用户']
        },
        {
          path: '/content',
          title: '内容管理',
          icon: 'el-icon-document',
          roles: ['管理员', '普通用户']
        },
        {
            path: '/material',
            title: '素材管理',
            icon: 'el-icon-picture-outline',
            roles: ['管理员'],
        },
        
        {
          path: '/article',
          title: '资料管理',
          icon: 'el-icon-folder-opened',
          roles: ['管理员'],
        },
        
        {
          path: '/contentGroup',
          title: '内容分组',
          icon: 'el-icon-collection-tag',
          roles: ['管理员', '普通用户']
        },
        // {
        //   path: '/contentTag',
        //   title: '内容标签',
        //   icon: 'el-icon-tag',
        //   roles: ['管理员', '普通用户']
        // },
        // {
        //   path: '/rwTable',
        //   title: '读字表/写字表',
        //   icon: 'el-icon-s-order',
        //   roles: ['管理员', '普通用户']
        // }
      ]
  

    if (!userRole) {
      return baseMenus;
    }

    return baseMenus.filter(menu => {
      return !menu.roles || menu.roles.includes(userRole);
    });
  },

  getApiBaseUrl() {
    return this.systemInfo.apiBaseUrl;
  },

  getDefaultAvatar() {
    return this.systemInfo.defaultAvatar;
  },

  getUserAvatarUrl(avatar) {
    if (!avatar) {
      return this.getDefaultAvatar();
    }
    
    const timestamp = new Date().getTime();
    const baseUrl = this.getApiBaseUrl();
    
    return this.systemInfo.userAvatarFormat
      .replace('{baseUrl}', baseUrl)
      .replace('{avatar}', avatar)
      .replace('{timestamp}', timestamp);
  }
};

export default systemService; 